<script setup>
import { useSettingsStore } from '../../stores/settings';
import Select from '../../../../library/form/components/Select.vue';

const { labels } = window.DATAGENT_PLUGIN_SETTINGS;

// Get the settings store
const settingsStore = useSettingsStore();

// handle model change
const handleModelChange = (e) => {
  if (e?.target?.value) {
    settingsStore.ollama.model = e.target.value;
  }
};
</script>

<template>
  <div
    id="dataagent-ollama-settings"
    class="dataagent-provider-settings da:mt-4 da:pt-4 da:border-t da:border-[#f5f5f5] da:transition-all da:duration-300 da:ease-in-out"
    :style="{ display: settingsStore.selectedProvider === 'ollama' ? 'block' : 'none' }"
  >
    <table class="form-table">
      <!-- Ollama Endpoint -->
      <tr>
        <th scope="row">
          <label for="dataagent_ollama_endpoint" class="da:block da:text-sm da:font-medium da:text-gray-700">{{
            labels.ollama_endpoint
          }}</label>
        </th>
        <td>
          <input
            type="text"
            id="dataagent_ollama_endpoint"
            v-model="settingsStore.ollama.endpoint"
            @input="settingsStore.fetchOllamaModels"
            class="regular-text da:w-full md:da:w-[250px] da:px-3 da:py-2 da:border da:border-gray-300 da:rounded-md da:shadow-sm da:focus:outline-none da:focus:ring-[#4CB21A] da:focus:border-[#4CB21A]"
          />
          <p class="description da:text-[#666] da:italic da:mt-1 da:text-xs">
            {{ labels.ollama_endpoint_description }}
          </p>
        </td>
      </tr>

      <!-- Ollama API Key -->
      <tr>
        <th scope="row">
          <label for="dataagent_ollama_api_key" class="da:block da:text-sm da:font-medium da:text-gray-700">{{
            labels.ollama_api_key
          }}</label>
        </th>
        <td>
          <input
            type="password"
            id="dataagent_ollama_api_key"
            v-model="settingsStore.ollama.apiKey"
            @input="settingsStore.fetchOllamaModels"
            class="regular-text da:w-full md:da:w-[250px] da:px-3 da:py-2 da:border da:border-gray-300 da:rounded-md da:shadow-sm da:focus:outline-none da:focus:ring-[#4CB21A] da:focus:border-[#4CB21A]"
          />
          <p class="description da:text-[#666] da:italic da:mt-1 da:text-xs">
            {{ labels.ollama_api_key_description }}
          </p>
        </td>
      </tr>

      <!-- Ollama Model -->
      <tr>
        <th scope="row">
          <label for="dataagent_ollama_model" class="da:block da:text-sm da:font-medium da:text-gray-700">{{
            labels.ollama_model
          }}</label>
        </th>
        <td>
          <template v-if="settingsStore.ollama.apiKey.length < 10">
            <p class="description da:text-[#666] da:italic da:mt-1 da:text-xs">
              {{ labels.enter_api_key_to_load_models }}
            </p>
          </template>
          <template v-else>
            <Select
              id="dataagent_ollama_model"
              @change="handleModelChange"
              :disabled="settingsStore.ollama.modelsLoading"
              class="select2 regular-text da:w-full md:da:w-[250px] da:px-3 da:py-2 da:border da:border-gray-300 da:rounded-md da:shadow-sm da:focus:outline-none da:focus:ring-[#4CB21A] da:focus:border-[#4CB21A] da:bg-white da:cursor-pointer"
              :value="settingsStore.ollama.model"
              :options="settingsStore.ollama.models"
            />
            <p class="description da:text-[#666] da:italic da:mt-1 da:text-xs">
              {{ labels.ollama_model_description }}
            </p>
          </template>
        </td>
      </tr>
    </table>
  </div>
</template>
